<template>
  <div class="content-tab sysinfo">
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="table-row dt">
          <div class="dt-r">
            <div class="title dt-c">{{$t('systemInfo.devicename')}}</div>
            <div class="dt-c">
              <div :title="systemInfo.hostname" class="value hostname" v-if="systemInfo && !isEdit">{{systemInfo.hostname}}</div>
              <div class="hostname" v-else>
                <input type="text" v-model="systemInfo.hostname" name="hostname" v-validate="'hostname|required'" :class="{'error': errors.has('hostname') }" @keyup="onBlur"/>
              </div>
              <div class="icon-edit" @click="onEdit" v-if="!isEdit" :title="$t('edit')"/>
              <div class="icon-tick" @click="onSave" v-else :disabled="isValidate" :title="$t('save')"/>
              <div class="icon-btn_close" @click="onCancel" v-if="isEdit" :title="$t('cancel')"/>
            </div>
          </div>
          <div class="dt-r">
            <div class="dt-c"></div>
            <div v-if="errors.has('hostname')" class="errorMessage dt-c">{{errors.first('hostname')}}</div>
          </div>
        </div>
        <div class="table-row">
          <div class="title">{{$t('overview.modelname')}}</div>
          <div :title="sysBoard.Product" class="value" v-if="sysBoard">{{sysBoard.Product}}</div>
        </div>
        <div class="table-row">
          <div class="title">{{$t('overview.macaddress')}} </div>
          <div :title="sysBoard.MacAddr" class="value" v-if="sysBoard">{{sysBoard.MacAddr}}</div>
        </div>
        <div class="table-row">
          <div class="title">{{$t('overview.ipaddress')}} </div>
          <div :title="ipAddress" class="value">{{ipAddressMag}}</div>
        </div>
        <div class="table-row">
          <div class="title">{{$t('updatefw.systemuptime')}} </div>
          <div :title="displayTime" class="value">{{displayTime}}
          </div>
        </div>
        <div class="table-row">
          <div class="title">{{$t('updatefw.fwVersion')}} </div>
          <div :title="fwinfo.version+'.'+fwinfo.number" class="value" v-if="fwinfo">{{fwinfo.version+'.'+fwinfo.number}}</div>
        </div>
        <div class="table-row" v-if="sensorStatus && sensorStatus.PowerInfo" v-for="(item, index) in sensorStatus.PowerInfo" :key="index">
          <div class="title">{{$t('overview.powerTitle', index + 1)}} </div>
          <div :title="getPowerMsg(item)" class="value">{{getPowerMsg(item)}}</div>
        </div>
      </scrollbar>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'
export default {
  name: 'SystemInformation',
  data () {
    return {
      isEdit: false,
      isEditChange: false,
      systemInfo: {},
      originalSysInfo: {},
      ipAddress: null,
      UpTime: null,
      systemFirmeware: '',
      infoInterval: null,
      isDHCP: false,
      isValidate: false,
      localStorageHostname: 'qsw_hostname'
    }
  },
  beforeDestroy () {
    clearInterval(this.infoInterval)
  },
  created () {
    let me = this
    this.$validator.extend('hostname', {
      getMessage (field, val) {
        let value = me.systemInfo.hostname
        // let temp = /^[\w\-_.]$/
        // let result = (!temp.test(value)) ? me.$t('errorMessage.hostnameInvaild') : me.$t('errorMessage.hostnamelength')
        let result = (value.length > 32 || value.length < 1) ? me.$t('errorMessage.hostnameLength', 32) : me.$t('errorMessage.hostnameInvaild')
        return result
      },
      validate (value, field) {
        var temp = /^[A-Za-z0-9-]{1,32}$/
        if (temp.test(value)) {
          return true
        }
        return false
      }
    })
  },
  mounted: async function () {
    this.updateSystemInfo()
    this.infoInterval = setInterval(() => {
      if (this.showFullLoading) {
        clearInterval(this.infoInterval)
        this.infoInterval = null
      } else {
        this.updateSystemInfo()
      }
    }, 60000)
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.infoInterval)
        this.infoInterval = null
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.infoInterval)
        }
      },
      immediate: true,
      deep: true
    },
    isEditChange: function (value) {
      this.$store.commit('updateDataChanged', value)
    }
  },
  methods: {
    updateSystemInfo: function () {
      let me = this
      this.getIpAddress()
      this.getSystemSensorStatus()
      this.axios.all([this.getSystemUptime(), this.getSystemInfo()])
        .then(this.axios.spread(function (time, info, sensor) {
          if (info.data && info.data.error_code === 200 && info.data.result) {
            let data = info.data.result
            me.systemInfo = data
            me.originalSysInfo = JSON.parse(JSON.stringify(me.systemInfo))
          }
          if (time.data && time.data.error_code === 200 && time.data.result) {
            me.UpTime = time.data.result.UpTime // sec
          }
        })).catch(error => {
          me.$log.error(error)
        })
    },
    getIpAddress: function () {
      this.getIP4Configure()
        .then((res) => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = res.data.result
            data.forEach(element => {
              if (element.key === '1') {
                if (element.val.enableInterface) {
                  if (element.val.enableDhcpClient) {
                    this.getInBandIpAddress()
                  } else {
                    this.ipAddress = element.val.ipv4Address
                  }
                } else {
                  this.getOutBandIpAddress()
                }
              }
            })
          }
        })
    },
    getInBandIpAddress: function () {
      this.getIP4Configure()
        .then((res) => {
          if (res.data && res.data.error_code === 200) {
            let data = res.data
            if (data.result) {
              data.result.forEach(element => {
                if (element.key === '1') {
                  this.ipAddress = element.val.ipv4Address
                }
              })
            }
          }
        })
    },
    getOutBandIpAddress: function () {
      this.getOobIP4Status()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = res.data.result
            data.forEach(element => {
              if (element.key === '1') {
                this.ipAddress = element.val.ipv4Address
              }
            })
          }
        })
    },
    onEdit () {
      this.isEdit = true
    },
    onSave () {
      this.setSystemInfo({
        Hostname: this.systemInfo.hostname,
        Contact: this.systemInfo.contact,
        Location: this.systemInfo.location
      }).then((result) => {
        if (result.data.error_code === 200) {
          document.title = this.systemInfo.hostname
          this.$localStorage.set(this.localStorageHostname, this.systemInfo.hostname)
          this.updateSystemInfo()
          this.isEdit = false
          this.isEditChange = false
        }
      }).catch((err) => {
        this.$log.error(err)
      })
    },
    onCancel () {
      this.isEdit = false
      this.isEditChange = false
      this.systemInfo.hostname = this.originalSysInfo.hostname
    },
    onBlur: function () {
      this.isEditChange = (this.systemInfo.hostname !== this.originalSysInfo.hostname)
      this.$validator.validateAll().then((result) => {
        this.isValidate = !result
      })
    },
    getPowerMsg: function (data) {
      let activeStatus = 'systemInfo.' + data.PowerActive.toLowerCase()
      let sourceStatus = 'systemInfo.' + data.PowerSource.toLowerCase()
      return this.$t(activeStatus) + ' (' + this.$t(sourceStatus) + ')'
    },
    ...mapActions([
      'getSystemUptime', 'getIP4Configure', 'getIP4Status', 'getOobIP4Status', 'getSystemInfo', 'setSystemInfo', 'getSystemSensorStatus'
    ]),
    ...mapMutations([])
  },
  computed: {
    ...mapState({
      isDataChanged: state => state.app.isDataChanged,
      showFullLoading: state => state.module.showFullLoading,
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo,
      sensorStatus: state => state.module.sensorStatus
    }),
    displayTime () {
      let sec = (this.UpTime) ? this.UpTime : '--'
      let time = sec + ' ' + this.$t('timestamp.sec')
      if (sec > 60) {
        var second = parseInt(sec) % 60
        var min = parseInt(sec / 60)
        time = min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
        if (min > 60) {
          min = parseInt(sec / 60) % 60
          var hour = parseInt(parseInt(sec / 60) / 60)
          time = hour + ' ' + this.$t('timestamp.hour') + ' ' + min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
          if (hour > 24) {
            hour = parseInt(parseInt(sec / 60) / 60) % 24
            var day = parseInt(parseInt(parseInt(sec / 60) / 60) / 24)
            time = day + ' ' + this.$t('timestamp.day') + ' ' + hour + ' ' + this.$t('timestamp.hour') + ' ' + min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
          }
        }
      }
      return time
    },
    ipAddressMag: function () {
      let result = this.$t('overview.loading')
      if (this.ipAddress) {
        result = this.ipAddress
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.content-tab {
  &.sysinfo {
    position: relative;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    .content-body {
      position: relative;
      width: 100%;
      padding: 20px 10px 10px 10px;
      overflow: overlay;
      .table-row {
        display: flex;
        display: -webkit-flex;
        margin-bottom: 10px;
        .title {
          margin-right: 5px;
          display: inline-block;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          font-size: 14px;
          font-weight: 500;
        }
        .value {
          display: inline-block;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          font-size: 14px;
          font-weight: 400;
        }
        .hostname {
          display: inline-block;
          width: auto;
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          >input {
            width: inherit;
          }
        }
        .icon-edit {
          display: inline-block;
        }
        .icon-tick, .icon-btn_close {
          display: inline-block;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: #197EC7;
          color: #ffffff;
          border-radius: 50%;
          text-align: center;
          &:hover {
            background: #1E93E6;
          }
          &:active {
            background: #105180;
          }
          &:focus {
            background: #105180;
          }
          &[disabled=disabled], &.disabled {
            pointer-events: none;
            background: rgba(169,169,169,0.30);
          }
          &:before {
            vertical-align: sub;
          }
        }
        .icon-btn_close {
          margin-left: 10px;
        }
      }
      .scrollbar-body {
        height: 100%;
        padding: 0px 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemInformation.vue